<template>
    <div    
      v-for="(charactarObject, index) in getCharsObj()"
      :key="index"
      class="char-layer"
    >
    <!-- {{ charactarObject.charFile.dstfile.pixelWidth }} ==
    {{ dpi }} -->
     <!-- * (scale != undefined ? scale : 1) -->
        <DSTPreview
          :dwidth="charactarObject.charFile.dstfile.pixelWidth * (scale != undefined ? scale : 1) * (dpi / 254.0)"
          :dheight="charactarObject.charFile.dstfile.pixelHeight * (scale != undefined ? scale : 1) * (dpi / 254.0)"
          :dstFile="charactarObject.charFile.dstfile"
          :layersColors="layersColors"
          :left="getLeft(index, charactarObject) * (scale != undefined ? scale : 1) * (dpi / 254.0)"
          :top="(charactarObject.y * (dpi / 254.0)) - getMinTop() * (scale != undefined ? scale : 1)"
          :transparent="superPos!=='normal'"
          :arc="charactarObject.arc"
          >
          <!-- :top="(charactarObject.y * (dpi / 254.0)) - ((store.allFonts.value[IDFontToPreview].sizes[IDSizeFontToPreview].FontHeight * this.dpi / 254) - getMaxTextHeight())" -->
          <!-- :top="(charactarObject.y * (dpi / 254.0))" -->
        </DSTPreview>
      &nbsp;
    </div>
</template>


<script>
import { designerStore } from "@/stores/designerStore"; 
import DSTPreview from "./DSTPreview.vue";

export default {
  setup() {
    const store = designerStore();
    return {
      store,
    };
  },
  components: {
    DSTPreview, 
  },
  data() {
    return {
      maxTextHeight: 0,
      list: [],
    };
  },
  props: ["IDFontToPreview", "IDSizeFontToPreview", "TextToPreview", "dpi", "superPos", "layersColors", "x", "y", "arc", "inDesign", "scale"],

// normal, alignLeft, alignRight

  beforeMount() {
    console.log(this.layersColors)
    // console.log("loyer")
    this.list = this.store.fromTextToCharsObjects(this.TextToPreview, this.x, this.y, this.IDFontToPreview, this.IDSizeFontToPreview,this.layersColors[0].colorID, this.arc).listChars;
  },
  methods: {
    getCharsObj() {
      this.list = this.store.fromTextToCharsObjects(this.TextToPreview, this.x, this.y, this.IDFontToPreview, this.IDSizeFontToPreview,this.layersColors[0].colorID, this.arc).listChars;
      return this.list;
    },
    getMaxTextHeight() {
      if (this.inDesign == true) {
        this.maxTextHeight = this.store.getMaxTextHeight(this.TextToPreview, this.IDFontToPreview, this.IDSizeFontToPreview) * this.dpi / 254;
      } else {
        this.maxTextHeight = this.store.allFonts.value[this.IDFontToPreview].sizes[this.IDSizeFontToPreview].FontHeight * this.dpi / 254;
      }
      return this.maxTextHeight;
    },
    getMinTop() {
      var min = 0;
      if(this.superPos == 'normal') {
        min = this.list.length == 0 ? 0 : this.list[0].y * (this.dpi / 254.0);
        for (var i = 1; i < this.list.length; i++) {
          min = this.list[i].y * this.dpi / 254 < min ? this.list[i].y * this.dpi / 254 : min;
        }
      } else {
        min = this.getMinTopFont();
      }
      return min;
    },
    getMinTopFont() {
      return Math.min(...Object.values(this.store.allFonts.value[this.IDFontToPreview].sizes[this.IDSizeFontToPreview].DictCharacters).map(f => -f.dyAlign));
    },
    getLeft(index, charactarObject){
       if (this.superPos == 'normal'){
        return charactarObject.x;
       } else if (this.superPos=='alignLeft') {
          return 0;
       } else if (this.superPos=='alignRight') {
         const mwidth=[...this.TextToPreview].map(x=>this.store.
            allFonts.value[this.IDFontToPreview].sizes[this.IDSizeFontToPreview]
            .DictCharacters[x].dstfile.pixelWidth ).reduce((x, y) => x > y ? x : y);
        return (mwidth - this.store.allFonts.value[this.IDFontToPreview].sizes[this.IDSizeFontToPreview]
                .DictCharacters[this.TextToPreview[index]].dstfile.pixelWidth) * ( this.dpi / 254.0);
       }
    },
  },
};
</script>

<style scoped>
.char-container {
  position: relative;
}
.char-layer {
  position: absolute;
  top: 0;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
